import moment from 'moment';
import { useState } from 'react';
import TableCompHead from '../../../../../components/ui/TableCompHead';
import DatePickerMui from '../../../../../components/common/DatePickerMui';
import formatDate from '../../../../../components/common/formatDate';
import { Grid, Stack } from '@mui/material';

import { TableInput } from '../../../../../components/common';
import { HeaderStandard, constants } from '../../constant';
import TableHeaderHtmlCustom from '../../../../../components/common/customTable/TableHeaderHtmlCustom';
import { TimePicker } from '@mui/x-date-pickers';
import { convToTime } from '../../../../../utils/helpers';
import { useQuery } from '../../../../../hooks/UseQuery';

interface IProps {
  head: any;
  handleChangeHead: any;
  isView: boolean;
}

const THead = ({ head, isView, handleChangeHead }: IProps) => {
  const { isReportLocked, _id } = head;
  const supplier_name = useQuery('supplier_name');
  const address = useQuery('address');
  const gst = useQuery('gst');
  const state = useQuery('state');

  return (
    <thead>
      <TableCompHead
        colSpan={11}
        rowSpan={3}
        labels={['Doc No', 'Rev', 'Dated']}
        values={['FM-STR-08', '01', '01-04-24']}
        heading={`${constants.moduleName}`}
      />
      <tr>
        <th colSpan={2} align="left">
          TECHNOCRAT CONNECTIVITY SYSTEMS PVT.LTD.
        </th>
        <th colSpan={3} align="left">
          Material Receipt report No.
        </th>
        <th colSpan={6} align="left">
          Dated
        </th>
      </tr>
      <tr>
        <td colSpan={2} style={{ textAlign: 'left' }}>
          PLOT NO-194B PHASE-VI SECTOR-37 GURUGRAM
        </td>
        <td colSpan={3} style={{ textAlign: 'left' }}>
          <TableInput
            isView={isView}
            disabled={head?._id}
            name="mrr_no"
            type="text"
            value={head.mrr_no}
            onChange={(e) => {
              handleChangeHead(e);
            }}
          />
        </td>
        <td colSpan={6} style={{ textAlign: 'left' }}>
          {isView || _id ? (
            head.mrr_date && formatDate(head.mrr_date)
          ) : (
            <DatePickerMui
              label=""
              value={(head.mrr_date && moment(head.mrr_date)) || null}
              onChange={(date) => {
                handleChangeHead({ target: { name: 'mrr_date', value: date } });
              }}
            />
          )}
        </td>
      </tr>
      <tr>
        <td colSpan={2} style={{ textAlign: 'left' }}>
          HARYANA{' '}
        </td>
        <th colSpan={3} style={{ textAlign: 'left' }}>
          Reference No. & Date.
        </th>
        <th colSpan={6} style={{ textAlign: 'left' }}>
          Other References
        </th>
      </tr>
      <tr>
        <td colSpan={2} style={{ textAlign: 'left' }}>
          GSTIN/UIN: 06AABCT2433N1ZA{' '}
        </td>
        <th colSpan={3} style={{ textAlign: 'left' }}>
          <Stack
            direction="row"
            spacing={1}
            justifyContent="center"
            alignItems="center"
          >
            <TableInput
              isView={isView || isReportLocked}
              name="ref_no"
              type="text"
              value={head.ref_no}
              onChange={(e) => {
                handleChangeHead(e);
              }}
            />
            {'  / '}

            {isView || isReportLocked ? (
              head.ref_date && formatDate(head.ref_date)
            ) : (
              <DatePickerMui
                label=""
                value={(head.ref_date && moment(head.ref_date)) || null}
                onChange={(date) => {
                  handleChangeHead({
                    target: { name: 'ref_date', value: date },
                  });
                }}
              />
            )}
          </Stack>
        </th>
        <th colSpan={6} style={{ textAlign: 'left' }}>
          <TableInput
            isView={isView || isReportLocked}
            name="other_ref"
            type="text"
            value={head.other_ref}
            onChange={(e) => {
              handleChangeHead(e);
            }}
          />
        </th>
      </tr>
      <tr>
        <td colSpan={2} style={{ textAlign: 'left' }}>
          State Name : Haryana, Code : 06{' '}
        </td>
        <th colSpan={3} rowSpan={2} style={{ textAlign: 'left' }}>
          Gate Entry No:{' '}
          <TableInput
            isView={isView || isReportLocked}
            name="gate_entry_no"
            type="text"
            value={head.gate_entry_no}
            onChange={(e) => {
              handleChangeHead(e);
            }}
          />
        </th>
        <th colSpan={3} rowSpan={2} style={{ textAlign: 'left' }}>
          Date:
          {isView || isReportLocked ? (
            head.gate_entry_date && formatDate(head.gate_entry_date)
          ) : (
            <DatePickerMui
              label=""
              value={
                (head.gate_entry_date && moment(head.gate_entry_date)) || null
              }
              onChange={(date) => {
                handleChangeHead({
                  target: { name: 'gate_entry_date', value: date },
                });
              }}
            />
          )}
        </th>
        <th colSpan={3} rowSpan={2} style={{ textAlign: 'left' }}>
          Time :
          {isView || isReportLocked ? (
            head.gate_entry_time && convToTime(head.gate_entry_time)
          ) : (
            <TimePicker
              label=""
              value={
                (head.gate_entry_time && moment(head.gate_entry_time)) || null
              }
              onChange={(date) => {
                handleChangeHead({
                  target: { name: 'gate_entry_time', value: date },
                });
              }}
            />
          )}
        </th>
      </tr>
      <tr>
        <td colSpan={2} style={{ textAlign: 'left' }}>
          E-Mail : tcs_subodh@hotmail.com
        </td>
      </tr>
      <tr>
        <th colSpan={2} style={{ textAlign: 'left' }}>
          Supplier Name{' '}
        </th>
        <th colSpan={3} style={{ textAlign: 'left' }}>
          Invoice No:
          <TableInput
            isView={isView || isReportLocked}
            name="invoice_no"
            type="text"
            value={head.invoice_no}
            onChange={(e) => {
              handleChangeHead(e);
            }}
          />
        </th>
        <th colSpan={3} style={{ textAlign: 'left' }}>
          Date:{' '}
          {isView || isReportLocked ? (
            head.invoice_date && formatDate(head.invoice_date)
          ) : (
            <DatePickerMui
              label=""
              value={(head.invoice_date && moment(head.invoice_date)) || null}
              onChange={(date) => {
                handleChangeHead({
                  target: { name: 'invoice_date', value: date },
                });
              }}
            />
          )}
        </th>
        <th colSpan={3} style={{ textAlign: 'left' }}>
          Time :{' '}
          {isView || isReportLocked ? (
            head.invoice_time && convToTime(head.invoice_time)
          ) : (
            <TimePicker
              label=""
              value={(head.invoice_time && moment(head.invoice_time)) || null}
              onChange={(date) => {
                handleChangeHead({
                  target: { name: 'invoice_time', value: date },
                });
              }}
            />
          )}
        </th>
      </tr>
      <tr>
        <th colSpan={2} style={{ textAlign: 'left' }}>
          {head?.supplier_id?.vender_name || supplier_name}
        </th>
        <th colSpan={9}>OR</th>
      </tr>
      <tr>
        <td colSpan={2} style={{ textAlign: 'left' }}>
          {head?.supplier_id?.address || address}
        </td>
        <th colSpan={3} style={{ textAlign: 'left' }}>
          Challan No:
          <TableInput
            isView={isView || isReportLocked}
            name="challan_no"
            type="text"
            value={head.challan_no}
            onChange={(e) => {
              handleChangeHead(e);
            }}
          />
        </th>
        <th colSpan={3} style={{ textAlign: 'left' }}>
          Date:{' '}
          {isView || isReportLocked ? (
            head.challan_date && formatDate(head.challan_date)
          ) : (
            <DatePickerMui
              label=""
              value={(head.challan_date && moment(head.challan_date)) || null}
              onChange={(date) => {
                handleChangeHead({
                  target: { name: 'challan_date', value: date },
                });
              }}
            />
          )}
        </th>
        <th colSpan={3} style={{ textAlign: 'left' }}>
          Time :
          {isView || isReportLocked ? (
            head.challan_time && convToTime(head.challan_time)
          ) : (
            <TimePicker
              label=""
              value={(head.challan_time && moment(head.challan_time)) || null}
              onChange={(date) => {
                handleChangeHead({
                  target: { name: 'challan_time', value: date },
                });
              }}
            />
          )}
        </th>
      </tr>
      <tr>
        <th colSpan={2} style={{ textAlign: 'left' }}>
          GSTIN/UIN: {head?.supplier_id?.gst_no || gst}
        </th>
        <td colSpan={3} style={{ textAlign: 'left' }}>
          Mode Of Delivery
        </td>
        <td colSpan={6} style={{ textAlign: 'left' }}>
          Vehcile No
        </td>
      </tr>
      <tr>
        <th colSpan={2} style={{ textAlign: 'left' }}>
          State Name :{head?.supplier_id?.state || state}
        </th>
        <th colSpan={3} style={{ textAlign: 'left' }}>
          <TableInput
            isView={isView || isReportLocked}
            name="mode_of_delivery"
            type="text"
            value={head.mode_of_delivery}
            onChange={(e) => {
              handleChangeHead(e);
            }}
          />
        </th>
        <th colSpan={6} style={{ textAlign: 'left' }}>
          <TableInput
            isView={isView || isReportLocked}
            name="vehicle_no"
            type="text"
            value={head.vehicle_no}
            onChange={(e) => {
              handleChangeHead(e);
            }}
          />
        </th>
      </tr>

      <TableHeaderHtmlCustom tableHeaderObj={HeaderStandard} />
    </thead>
  );
};

export default THead;
